module.exports = __webpack_public_path__ + "static/media/test-review.6fa868fd.svg";